export default __webpack_public_path__ + "static/media/icoSuccess-1.75e19918.svg";